import * as React from 'react';
import { DataLayer } from '@grandvisionhq/analytics';
import { Button } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { storesLocatorResultEvent } from '../../../data-layer/actions.js';
import { useBookAppointmentUrl } from '../../../hooks/use-book-appointment-url.js';
import { useStoreFinderContext } from '../../../context/StoreFinder/context.js';
import { areServicesAvailable } from '../../../utils/store-utils.js';

const BookAppointmentButtonContainer = ({ store: store1 , view , isPreferredStore ,  })=>{
    const { getLabel  } = useIntl();
    const { stores , urls  } = useStoreFinderContext();
    const bookAppointmentUrl = useBookAppointmentUrl(urls === null || urls === void 0 ? void 0 : urls.bookAppointment, store1);
    const showBookAppointmentCTA = areServicesAvailable(store1, [
        Types.ServicesNotAvailable.APPOINTMENTS, 
    ]);
    const { code  } = store1;
    const onStoresLocatorResultEvent = React.useCallback(({ store , preferredStore , interaction , searchPosition , searchResults  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            preferredStore,
            searchPosition,
            searchResults
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onBookAppointmentButtonClickHandler = React.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'book appointment click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            preferredStore: isPreferredStore,
            interaction: 'map click - book appointment',
            searchResults: stores.length
        });
        window.location.assign(bookAppointmentUrl);
    }, [
        onStoresLocatorResultEvent,
        view,
        store1,
        isPreferredStore,
        stores,
        bookAppointmentUrl
    ]);
    if (!showBookAppointmentCTA) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(Button, {
        onClick: onBookAppointmentButtonClickHandler,
        variant: "solid",
        size: "small",
        "data-t": `book-appointment-${code}`,
        caption: getLabel('stores.page.storeGroup.action.bookAppointment')
    });
};
var BookAppointmentButtonContainer$1 = BookAppointmentButtonContainer;

export { BookAppointmentButtonContainer$1 as default };
//# sourceMappingURL=BookAppointmentButtonContainer.js.map
